import React from 'react'
import { makeStyles, createStyles, Box, fade } from '@material-ui/core'
import { ReactComponent as VolumeUpIcon } from 'src/mobile/assets/icons/volume-up.svg'
import { ReactComponent as EditIcon } from 'src/mobile/assets/icons/edit-2.svg'
// import { ReactComponent as Close } from 'src/mobile/assets/icons/closeTop.svg'

import classnames from 'classnames'
// import useUserSession from 'src/hooks/useUserSession'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0, 2),
      backgroundColor: '#359DEC',
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'break-spaces',
      fontSize: theme.spacing(2),
    },
    container: {
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'break-spaces',
      fontSize: theme.spacing(2),
    },
    icon: {
      width: theme.spacing(2.75),
      height: theme.spacing(2.75),
      flexShrink: 0,
      marginRight: theme.spacing(0.25),
      // marginRight:0,
      marginTop: 1,
    },
    icon2: {
      position: 'absolute',
      width: theme.spacing(1.75),
      height: theme.spacing(1.75),
      flexShrink: 0,
      right: theme.spacing(1.25),
      marginTop: 1,
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    helperText: {
      color: theme.palette.grey[400],
      '& $icon path': {
        fill: fade(theme.palette.secondary.main, 0.6),
      },
    },
  }),
)

const SnackbarHelperText = ({ children, type }) => {
  const classes = useStyles()
  // const { authenticated } = useUserSession()
  // const [open, setOpen] = useState(true)

  // const handleClose = (params) => setOpen(false)

  return (
    <Box
      className={classnames(classes.root, {
        [classes.helperText]: type === 'helperText',
      })}
    >
      <Box className={classes.container}>
        {type === 'helperText' ? (
          <EditIcon className={classes.icon} />
        ) : (
          <VolumeUpIcon className={classes.icon} />
        )}
        {children}
        {/* <Close className={classes.icon2} onClick={handleClose} /> */}
      </Box>
    </Box>
  )
}

export default SnackbarHelperText
